import React, { useEffect } from "react";
import ReactECharts from "echarts-for-react";

const GraphRaw = ({ module, gid, setUpdated }) => {
  const [mergedOptions, setMergedOptions] = React.useState(null);

  useEffect(() => {
    if (module.updated) {
      setUpdated(module.updated);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { axisLabelFormat } = module;

  React.useEffect(() => {
    if (!mergedOptions) {
      if (module.data) {
        let nObj = {
          ...module.data,
          grid: { top: 20, left: 5, right: 20, containLabel: true },
        };
        if (axisLabelFormat) {
          if (axisLabelFormat === "kr") {
            nObj.yAxis.axisLabel = {
              formatter: function (value) {
                return value.toLocaleString("nb-NO") + ",-kr";
              },
            };
            nObj.tooltip = {
              trigger: "axis",
              order: "valueDesc",
              formatter: function (params) {
                let tooltip = `${params[0].name} <br/>`;
                params.forEach((item) => {
                  tooltip += `${item.marker} ${item.seriesName}: ${item.value.toLocaleString("nb-NO")},-kr <br/>`;
                });
                return tooltip;
              },
            };
          }
          if (axisLabelFormat === "percentage") {
            nObj.xAxis.axisLabel = {
              formatter: function (value) {
                return value + "%";
              },
            };
            nObj.tooltip = {
              trigger: "axis",
              order: "valueDesc",
              formatter: function (params) {
                let tooltip = `${params[0].name} <br/>`;
                params.forEach((item) => {
                  tooltip += `${item.marker} ${item.seriesName}: ${item.value}% <br/>`;
                });
                return tooltip;
              },
            };
          }
        }
        setMergedOptions(nObj);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (mergedOptions) {
    return <ReactECharts option={mergedOptions} style={{ marginTop: "40px" }} />;
  }

  return null;
};
export default GraphRaw;
